export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [`Ширина`, `43`, `47`, `48`, `50`, `55`, `58`, `60`, `64`, `65`, `66`],
  [`Длина`, `65`, `66`, `67`, `69`, `73`, `75`, `76`, `77`, `81`, `82`]
];

